import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f7feb20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  class: "center"
}
const _hoisted_3 = { class: "grid-container" }
const _hoisted_4 = {
  key: 0,
  class: "ma-3 text-green-500"
}
const _hoisted_5 = { class: "flex-column align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex-column align-items-center" }
const _hoisted_10 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_11 = {
  key: 1,
  class: "ma-3"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex-column align-items-center" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_16 = { class: "flex-column align-items-center" }
const _hoisted_17 = { class: "card-container" }
const _hoisted_18 = { class: "player-container" }
const _hoisted_19 = { class: "player-details" }
const _hoisted_20 = { class: "player-info" }
const _hoisted_21 = { class: "player-info" }
const _hoisted_22 = { class: "player-info" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "player-info" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "player-info" }
const _hoisted_29 = { class: "player-info" }
const _hoisted_30 = { class: "player-details" }
const _hoisted_31 = { class: "player-info" }
const _hoisted_32 = { class: "player-info" }
const _hoisted_33 = { class: "player-info" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "player-info" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "player-info" }
const _hoisted_40 = { class: "player-info" }
const _hoisted_41 = { class: "flex-column align-items-center" }
const _hoisted_42 = { class: "flex-column align-items-center" }
const _hoisted_43 = { class: "flex-column align-items-center" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import {
  getInfoTorneoEquipoCreado,
  guardarResultados,
} from "@/services/TorneosService";
import {
  ClasificacionEquipo,
  GuardarResultadosDTO,
  InscripcionTorneoCreadoDTO,
  ResultadoJugador,
} from "@/interfaces/Torneo";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import ModalAddEscenarioPartida from "@/components/ResultadosTorneos/ModalAddEscenarioPartida.vue";
import ModalAddPuntosPartida from "@/components/ResultadosTorneos/ModalAddPuntosPartida.vue";
import ModalLiderPartida from "@/components/ResultadosTorneos/ModalLiderPartida.vue";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalValidarPartida from "@/components/ResultadosTorneos/ModalValidarPartida.vue";
import { ListaTorneoRequestDTO } from "@/interfaces/Lista";
import {
  Clasificacion,
  GenerarRonda,
  RequestUpdatePairingTorneoDTO,
  UpdatePartidaTorneoDTO,
} from "@/interfaces/Live";
import {
  ActualizarPairingEquiposDTO,
  PartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { Torneo } from "@/interfaces/Torneo";
import { getlistaTorneo } from "@/services/ListasService";
import {
  updatePairingTorneo,
  updatePartidaTorneo,
} from "@/services/PartidaTorneoService";
import {
  getPartidasTorneo,
  getTorneo,
  isSaveTournament,
} from "@/services/TorneosService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalEditarPartidaGestion from "@/components/GestionTorneos/ModalEditarPartidaGestion.vue";
import ModalEliminarPartidaTorneo from "@/components/GestionTorneos/ModalEliminarPartidaTorneo.vue";
import { appsettings } from "@/settings/appsettings";
import ModalAgregarPairing from "@/components/GestionTorneos/ModalAgregarPairing.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalParametrosRondasEquipo from "@/components/GestionTorneos/Equipos/ModalParametrosRondasEquipo.vue";
import CardGestionInfoTorneoEquipo from "@/components/GestionTorneos/Equipos/CardGestionInfoTorneoEquipo.vue";
import CardGestionAccionesTorneoEquipo from "@/components/GestionTorneos/Equipos/CardGestionAccionesTorneoEquipo.vue";
import CardInfoEquipo from "@/components/GestionTorneos/Equipos/CardInfoEquipo.vue";
import { ListaDTO } from "@/interfaces/Usuario";
import TabClasificacionEquipos from "@/components/GestionTorneos/Equipos/TabClasificacionEquipos.vue";
import ModalCambiarPairingEquipoGestion from "@/components/PartidasTorneo/ModalCambiarPairingEquipoGestion.vue";
import CardEmparejamientosGestion from "@/components/GestionTorneos/Equipos/CardEmparejamientosGestion.vue";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoGestionEquiposView',
  setup(__props) {

const isLoadingImage = ref<boolean>(false);
const torneo = ref<Torneo>();
const partidas = ref<PartidaTorneoDTO[]>([]);
const numeroRondas = ref<number[]>([]);
const activeTab = ref<number>(0);
const partidasPorRonda = ref<Record<number, PartidaTorneoDTO[]>>({});
const idUsuario = ref<number>();
const isModalListaVisible = ref<boolean>(false);
const listaData = ref<string>("");
const nickJugador = ref<string>("");
const idPartidaSeleccionada = ref<number>();
const usuarioSeleccionado = ref<1 | 2>();
const isModalPuntosVisible = ref<boolean>(false);
const isModalLiderVisible = ref<boolean>(false);
const isModalEscenarioVisible = ref<boolean>(false);
const isModalValidarVisible = ref<boolean>(false);
const showErrorCambiarPairingModal = ref<boolean>(false);
const tabClasificacion = ref<number>();
const route = useRoute();
const idTorneo = ref<number>();
const isLoading = ref<boolean>(false);
const torneoGestion = ref<TorneoEquipoGestionInfoDTO | null>(null);
const clasificacion = ref<Clasificacion[]>([]);
const jugadoresZona1 = ref<Clasificacion[]>([]);
const jugadoresZona2 = ref<Clasificacion[]>([]);
const rondaAGenerar = ref<number>(0);
const showConfigModal = ref<boolean>(false);
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const ultimaRonda = ref<number>();
const hasGanador = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const isGenerating = ref<boolean>(false);
const showModificarPartidaTorneoModal = ref<boolean>(false);
const showModificarPairingModal = ref<boolean>(false);
const showAgregarPairingModal = ref<boolean>(false);
const showEliminarPartidaModal = ref<boolean>(false);
const estaRondaUnoGenerada = ref<boolean>(false);
const partidaActual = ref<PartidaTorneoDTO>({
  ejercitoUsuario1: null,
  ejercitoUsuario2: null,
  escenarioPartida: null,
  fechaPartida: "",
  ganadorPartidaTorneo: null,
  idPartidaTorneo: 0,
  idTorneo: 0,
  idUsuario1: 0,
  idUsuario2: 0,
  liderMuertoUsuario1: null,
  liderMuertoUsuario2: null,
  nick1: "",
  nick2: "",
  numeroRonda: 0,
  partidaValidadaUsuario1: null,
  partidaValidadaUsuario2: null,
  resultadoUsuario1: null,
  resultadoUsuario2: null,
  idEquipo1: null,
  idEquipo2: null,
  nombreEquipo1: null,
  nombreEquipo2: null,
  idCapitan1: null,
  idCapitan2: null,
});
const idRondaSelected = ref<number>(0);
const wasSave = ref<boolean>(false);
const currentEjercito = ref<string>();
const listaDTO = ref<ListaDTO>();
const clasificacionEquipos = ref<ClasificacionEquipo[]>([]);
const inscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);

//Variables para el buscador
const busquedaEquipo = ref<string>("");
const equiposFiltrados = computed(() => {
  if (!torneoGestion.value) return [];
  return torneoGestion.value.equipos.filter((equipo) =>
    (equipo.nombreEquipo?.toLowerCase() || "").includes(
      busquedaEquipo.value.toLowerCase()
    )
  );
});

function manejarClasificacion(clasificacion: ClasificacionEquipo[]) {
  clasificacionEquipos.value = clasificacion;
}

onMounted(async () => {
  idTorneo.value = parseInt(route.params.idTorneo.toString());

  isLoading.value = true;

  try {
    const responseTorneo = await getInfoTorneoEquipoCreado(idTorneo.value);
    torneoGestion.value = responseTorneo.data;
  } catch (error) {
    console.error(error);
    router.push({ name: "error" });
  }

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneo.value = responseTorneo.data;

    const responsePartidas = await getPartidasTorneo(idTorneo.value);
    partidas.value = responsePartidas.data;

    if (torneoGestion.value) {
      numeroRondas.value = Array.from(
        { length: torneoGestion.value.torneo.numeroPartidas },
        (_, index) => index + 1
      );
    }
    if (partidas.value) {
      partidasPorRonda.value = partidas.value.reduce((acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      }, {} as Record<number, PartidaTorneoDTO[]>);
    }

    if (partidas.value.length > 0) estaRondaUnoGenerada.value = true;

    tabClasificacion.value = numeroRondas.value.length + 1;

    try {
      const responseInscripciones = await getInscripcionesTorneo(
        idTorneo.value
      );
      inscripciones.value = responseInscripciones.data;
    } catch (error) {
      console.error(error);
    }

    calcularClasificacion();

    let ganador: number | null = null;
    ultimaRonda.value = numeroRondas.value.length;
    if (clasificacionZona1.value && clasificacionZona1.value.length > 0) {
      ganador = clasificacionZona1.value[0].idUsuario;
    }
    hasGanador.value = ganador !== null;

    ultimaRonda.value = numeroRondas.value.length;
    if (clasificacionZona1.value[0] != undefined) {
      ganador = clasificacionZona1.value[0].idUsuario;
    }
    if (ganador != null) hasGanador.value = true;

    const isSave = await isSaveTournament(idTorneo.value);
    wasSave.value = isSave.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
});

const resultados = async (ronda: number) => {
  // //TODO  domadores
  // if (torneo.value?.idTorneo == 7) {
  //   try {
  //     isGenerating.value = true;
  //     const resultados1: Resultado[] = clasificacionZona1.value.map(
  //       (clasificacion, index) => {
  //         return {
  //           idUsuario: clasificacion.idUsuario,
  //           idTorneo: torneo.value?.idTorneo,
  //           resultado: index + 1,
  //         };
  //       }
  //     );

  //     await guardarResultados(resultados1);

  //     const resultados2: Resultado[] = clasificacionZona2.value.map(
  //       (clasificacion, index) => {
  //         return {
  //           idUsuario: clasificacion.idUsuario,
  //           idTorneo: torneo.value?.idTorneo,
  //           resultado: index + 1,
  //         };
  //       }
  //     );

  //     await guardarResultados(resultados2);

  //     showSuccessModal.value = true;
  //   } catch (error) {
  //     showErrorModal.value = true;
  //     console.error(error);
  //   } finally {
  //     isGenerating.value = false;
  //   }

  try {
    isGenerating.value = true;
    const ganadores: ResultadoJugador[] = clasificacion.value.map(
      (clasi, index) => {
        return {
          idUsuario: clasi.idUsuario,
          idTorneo: torneo.value?.idTorneo,
          resultado: index + 1,
        };
      }
    );
    const idTorneo: number | undefined = torneo.value?.idTorneo;

    if (idTorneo == undefined) return;

    const partidasUltimasRonda: GenerarRonda = {
      emparejamientos: [],
      luzVsOscCheck: false,
      mismaComunidadCheck: false,
      retosCheck: false,
      esEloCheck: false,
      opcionImpares: null,
      idTorneo: idTorneo,
      idRonda: ronda,
      isTorneoNarsil: false,
    };

    const guardarResultadosDTO: GuardarResultadosDTO = {
      ganadoresDTO: ganadores,
      generarRondaDTO: partidasUltimasRonda,
    };
    await guardarResultados(guardarResultadosDTO);
    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }
};

const closeConfigModal = () => {
  showConfigModal.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
  window.location.reload();
};

const closeModificarPartidaTorneoModal = () => {
  showModificarPartidaTorneoModal.value = false;
};

const handleEquipoEliminado = (idEquipo: number) => {
  if (torneoGestion.value) {
    torneoGestion.value.equipos = torneoGestion.value.equipos.filter(
      (e) => e.idEquipo !== idEquipo
    );
  }
};

const handleModificarPartidaTorneoConfirm = async (
  partidaEditada: PartidaTorneoDTO
) => {
  isGenerating.value = true;

  if (partidaEditada !== null) {
    try {
      await updatePartidaTorneo(partidaEditada);
      showSuccessModal.value = true;
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    } finally {
      isGenerating.value = false;
      closeModificarPartidaTorneoModal();
    }
  }
};

// Watch para detectar cuando se cierra el modal de éxito
watch(
  () => showSuccessModal.value,
  (newValue, oldValue) => {
    if (oldValue && !newValue) {
      recargarPagina();
    }
  }
);

const modificarPartida = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showModificarPartidaTorneoModal.value = true;
};

const recargarPagina = () => {
  window.location.reload();
};

const closeAgregarPairingModal = () => {
  showAgregarPairingModal.value = false;
};

const closeEliminarPartidaModal = () => {
  showEliminarPartidaModal.value = false;
};

const handleEliminarPartidaConfirm = () => {
  try {
    showSuccessModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    closeEliminarPartidaModal();
  }
};

const modificarPairing = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showModificarPairingModal.value = true;
};

const agregarPairing = (idRonda: number) => {
  idRondaSelected.value = idRonda;
  showAgregarPairingModal.value = true;
};

const eliminarPartida = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showEliminarPartidaModal.value = true;
};

const generarSiguienteRonda = (ronda: number) => {
  try {
    rondaAGenerar.value = ronda;
    showConfigModal.value = true;
  } catch (error) {
    console.error("Error al generar la siguiente ronda:", error);
  }
};

const calcularClasificacion = () => {
  const ranking: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};
  const rankingDividido: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};

  // Filtramos hasta la ronda 2 para dividir el grupo
  const partidasFiltradas = partidas.value?.filter(
    (partida) => partida.numeroRonda <= 2
  );

  partidasFiltradas?.forEach((partida) => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!rankingDividido[partida.idUsuario1]) {
        rankingDividido[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!rankingDividido[partida.idUsuario2]) {
        rankingDividido[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      rankingDividido[partida.idUsuario1].puntosFavor += puntosUsuario1;
      rankingDividido[partida.idUsuario1].puntosContra += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosFavor += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      rankingDividido[partida.idUsuario1].diferenciaPuntos =
        rankingDividido[partida.idUsuario1].puntosFavor -
        rankingDividido[partida.idUsuario1].puntosContra;
      rankingDividido[partida.idUsuario2].diferenciaPuntos =
        rankingDividido[partida.idUsuario2].puntosFavor -
        rankingDividido[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
        rankingDividido[partida.idUsuario1].puntosTorneo += 3;
        rankingDividido[partida.idUsuario1].victorias += 1;
        rankingDividido[partida.idUsuario2].derrotas += 1;
      } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
        rankingDividido[partida.idUsuario2].puntosTorneo += 3;
        rankingDividido[partida.idUsuario2].victorias += 1;
        rankingDividido[partida.idUsuario1].derrotas += 1;
      } else {
        rankingDividido[partida.idUsuario1].puntosTorneo += 1;
        rankingDividido[partida.idUsuario2].puntosTorneo += 1;
        rankingDividido[partida.idUsuario1].empates += 1;
        rankingDividido[partida.idUsuario2].empates += 1;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        rankingDividido[partida.idUsuario1].lider += 1;
      } else if (liderMuertoUsuario2) {
        rankingDividido[partida.idUsuario2].lider += 1;
      }
    }
  });

  clasificacionDividida.value = Object.values(rankingDividido).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  dividirClasificacionEnZonas();

  // Clasificacion normal
  partidas.value?.forEach((partida) => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!ranking[partida.idUsuario1]) {
        ranking[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!ranking[partida.idUsuario2]) {
        ranking[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      ranking[partida.idUsuario1].puntosFavor += puntosUsuario1;
      ranking[partida.idUsuario1].puntosContra += puntosUsuario2;
      ranking[partida.idUsuario2].puntosFavor += puntosUsuario2;
      ranking[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      ranking[partida.idUsuario1].diferenciaPuntos =
        ranking[partida.idUsuario1].puntosFavor -
        ranking[partida.idUsuario1].puntosContra;
      ranking[partida.idUsuario2].diferenciaPuntos =
        ranking[partida.idUsuario2].puntosFavor -
        ranking[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
        ranking[partida.idUsuario1].puntosTorneo += 3;
        ranking[partida.idUsuario1].victorias += 1;
        ranking[partida.idUsuario2].derrotas += 1;
      } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
        ranking[partida.idUsuario2].puntosTorneo += 3;
        ranking[partida.idUsuario2].victorias += 1;
        ranking[partida.idUsuario1].derrotas += 1;
      } else {
        ranking[partida.idUsuario1].puntosTorneo += 1;
        ranking[partida.idUsuario2].puntosTorneo += 1;
        ranking[partida.idUsuario1].empates += 1;
        ranking[partida.idUsuario2].empates += 1;
      }
      // Lider muerto primero
      if (liderMuertoUsuario1) {
        ranking[partida.idUsuario1].lider += 1;
      } else if (liderMuertoUsuario2) {
        ranking[partida.idUsuario2].lider += 1;
      }
    }
  });

  inscripciones.value.forEach((inscripcion) => {
    const userId = inscripcion.idUsuario;
    if (ranking[userId]) {
      ranking[userId].puntosTorneo += inscripcion.puntosExtra;
    }
  });

  clasificacion.value = Object.values(ranking).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  // Clasificacion por zonas
  clasificacionZona1.value = clasificacion.value.filter((jugador) =>
    jugadoresZona1.value.some((z) => z.idUsuario === jugador.idUsuario)
  );

  clasificacionZona2.value = clasificacion.value.filter((jugador) =>
    jugadoresZona2.value.some((z) => z.idUsuario === jugador.idUsuario)
  );

  type JugadorConEjercito = {
    nick: string;
    ejercito: string | null;
  };

  const jugadoresConEjercitos = partidas.value.reduce<JugadorConEjercito[]>(
    (acc, partida) => {
      acc.push({ nick: partida.nick1, ejercito: partida.ejercitoUsuario1 });
      acc.push({ nick: partida.nick2, ejercito: partida.ejercitoUsuario2 });
      return acc;
    },
    []
  );

  const listaEjercitos = appsettings.armies;

  const ejercitosJugadoresConBando = jugadoresConEjercitos.map((jugador) => {
    const ejercito = listaEjercitos.find((e) => e.name === jugador.ejercito);
    return {
      nick: jugador.nick,
      ejercito: jugador.ejercito,
      bando: ejercito ? ejercito.band : "desconocido",
      shortName: ejercito?.shortName,
    };
  });

  clasificacion.value = clasificacion.value.map((j) => {
    const datosEjercito = ejercitosJugadoresConBando.find(
      (e) => e.nick === j.nick
    );
    return {
      ...j,
      bando: datosEjercito?.bando ?? "desconocido",
      nombreCortoEjercito: datosEjercito?.shortName ?? undefined,
      ejercito: datosEjercito?.ejercito ?? undefined,
    };
  });
};

const dividirClasificacionEnZonas = () => {
  const totalJugadores = clasificacionDividida.value.length;
  const esImpar = totalJugadores % 2 !== 0;

  const mitad = Math.floor(totalJugadores / 2);
  let zona1Size = esImpar ? mitad + 1 : mitad;
  if (zona1Size % 2 !== 0) zona1Size = zona1Size + 1;

  jugadoresZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  jugadoresZona2.value = clasificacionDividida.value.slice(zona1Size);
};

const isRondaValidada = (numeroRonda: number) => {
  if (!partidasPorRonda.value[numeroRonda]) {
    return false;
  }

  return partidasPorRonda.value[numeroRonda].every(
    (partida) =>
      partida.partidaValidadaUsuario1 === true &&
      partida.partidaValidadaUsuario2 === true
  );
};

const getGanador = (partida: PartidaTorneoDTO) => {
  if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
    return partida.nick1;
  } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
    return partida.nick2;
  } else {
    return "Empate";
  }
};

const verLista = async (idUsuario: number, idTorneo: number, nick: string) => {
  isLoadingImage.value = true;
  if (idTorneo && idUsuario && nick) {
    const body: ListaTorneoRequestDTO = {
      idTorneo: idTorneo,
      idUsuario: idUsuario,
    };

    try {
      const listaResponse = await getlistaTorneo(body);
      listaDTO.value = listaResponse.data;
      if (listaDTO.value != undefined)
        listaData.value = listaDTO.value.listaData ?? "";
      nickJugador.value = nick;
      currentEjercito.value = listaDTO.value?.ejercito;
      isModalListaVisible.value = true;
    } catch (error) {
      console.error(error);
      isModalListaVisible.value = false;
      isLoadingImage.value = false;
    } finally {
      isLoadingImage.value = false;
    }
  }
};

const abrirModalValidar = (idPartida: number, usuario: 1 | 2) => {
  idPartidaSeleccionada.value = idPartida;
  usuarioSeleccionado.value = usuario;
  isModalValidarVisible.value = true;
};

const confirmarPuntos = async (puntos: number) => {
  if (idPartidaSeleccionada.value && usuarioSeleccionado.value !== null) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    if (usuarioSeleccionado.value === 1) body.resultadoUsuario1 = puntos;
    else body.resultadoUsuario2 = puntos;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error(error);
    } finally {
      isModalPuntosVisible.value = false;
      window.location.reload();
    }
  }
};

const confirmarLider = async (lider: boolean) => {
  if (idPartidaSeleccionada.value && usuarioSeleccionado.value !== null) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    if (usuarioSeleccionado.value === 1) body.liderMuertoUsuario1 = lider;
    else body.liderMuertoUsuario2 = lider;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error(error);
    } finally {
      isModalLiderVisible.value = false;
      window.location.reload();
    }
  }
};

const confirmarEscenario = async (escenario: string) => {
  if (idPartidaSeleccionada.value) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    body.escenarioPartida = escenario;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error(error);
    } finally {
      isModalEscenarioVisible.value = false;
      window.location.reload();
    }
  }
};

const confirmarValidar = async () => {
  if (idPartidaSeleccionada.value) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    if (usuarioSeleccionado.value === 1) body.partidaValidadaUsuario1 = true;
    else body.partidaValidadaUsuario2 = true;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error(error);
    } finally {
      isModalValidarVisible.value = false;
      window.location.reload();
    }
  }
};

const cerrarModal = () => {
  isModalPuntosVisible.value = false;
};

const cerrarModalLider = () => {
  isModalLiderVisible.value = false;
};

const cerrarModalEscenario = () => {
  isModalEscenarioVisible.value = false;
};

const cerrarModalValidar = () => {
  isModalValidarVisible.value = false;
};

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const sendUpdateBack = async (idJugador1: number, idJugador2: number) => {
  try {
    const body: RequestUpdatePairingTorneoDTO = {
      idPartidaTorneo: partidaActual.value.idPartidaTorneo,
      idUsuario1: idJugador1,
      idUsuario2: idJugador2,
    };

    await updatePairingTorneo(body);
    return true;
  } catch (error) {
    console.error(error);
    showErrorCambiarPairingModal.value = true;
    return false;
  }
};

const actualizarPairing = async (payload: ActualizarPairingEquiposDTO) => {
  isGenerating.value = true;
  const isUpdate: boolean = await sendUpdateBack(
    payload.idJugador1,
    payload.idJugador2
  );

  if (isUpdate) {
    partidaActual.value.idUsuario1 = payload.idJugador1;
    partidaActual.value.idUsuario2 = payload.idJugador2;
    partidaActual.value.ejercitoUsuario1 = payload.ejercitoEquipo1;
    partidaActual.value.ejercitoUsuario2 = payload.ejercitoEquipo2;
    partidaActual.value.nick1 = payload.nick1;
    partidaActual.value.nick2 = payload.nick2;
  }
  showModificarPairingModal.value = false;
  isGenerating.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_item = _resolveComponent("v-tabs-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(LoadingGandalf)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_card, {
                      class: "mx-auto",
                      "max-width": "800"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tabs, {
                          modelValue: activeTab.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                          grow: "",
                          "center-active": "",
                          "fixed-tabs": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: 0,
                              text: `Gestión`,
                              value: 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Gestión")
                              ]),
                              _: 1
                            })),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroRondas.value, (n) => {
                              return (_openBlock(), _createBlock(_component_v_tab, {
                                key: n,
                                text: `Ronda ${n}`,
                                value: n
                              }, null, 8, ["text", "value"]))
                            }), 128)),
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: tabClasificacion.value,
                              text: `Clasificación`,
                              value: tabClasificacion.value
                            }, null, 8, ["value"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_v_window, {
                          modelValue: activeTab.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeTab).value = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_window_item, {
                              value: 0,
                              key: 0
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(CardGestionInfoTorneoEquipo, { torneo: torneoGestion.value }, null, 8, ["torneo"]),
                                  _createVNode(CardGestionAccionesTorneoEquipo, {
                                    torneo: torneoGestion.value,
                                    rondaGenerada: estaRondaUnoGenerada.value
                                  }, null, 8, ["torneo", "rondaGenerada"]),
                                  _createVNode(_component_v_text_field, {
                                    modelValue: busquedaEquipo.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((busquedaEquipo).value = $event)),
                                    label: "Buscar equipo por nombre",
                                    "prepend-inner-icon": "mdi-magnify",
                                    variant: "tonal",
                                    clearable: "",
                                    class: "ma-4",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposFiltrados.value, (equipo) => {
                                      return (_openBlock(), _createBlock(CardInfoEquipo, {
                                        key: equipo.idEquipo,
                                        equipo: equipo,
                                        torneo: torneo.value!,
                                        onDeleteTeam: ($event: any) => (handleEquipoEliminado(equipo.idEquipo))
                                      }, null, 8, ["equipo", "torneo", "onDeleteTeam"]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _: 1
                            })),
                            (isRondaValidada(activeTab.value))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createTextVNode(" Todas las partidas están validadas "),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_v_list_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_content, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, [
                                                  _createVNode(_component_v_btn, {
                                                    class: "mt-2",
                                                    variant: "tonal",
                                                    color: "secondary",
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (agregarPairing(activeTab.value)))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Añadir partida ")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (ultimaRonda.value != activeTab.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        (partidasPorRonda.value[activeTab.value + 1] != undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " La ronda " + _toDisplayString(activeTab.value + 1) + " ya se ha generado ", 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_content, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_9, [
                                                            _createVNode(_component_v_btn, {
                                                              class: "mt-2",
                                                              variant: "tonal",
                                                              color: "primary",
                                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (generarSiguienteRonda(activeTab.value + 1)))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(" Generar siguiente ronda ")
                                                              ]),
                                                              _: 1
                                                            })
                                                          ])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        (hasGanador.value && !wasSave.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              class: "mt-2",
                                              variant: "tonal",
                                              color: "primary",
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (resultados(activeTab.value)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Guardar resultados ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (
                    !partidasPorRonda.value[activeTab.value] &&
                    activeTab.value != 0 &&
                    activeTab.value != numeroRondas.value.length + 1
                  )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createTextVNode(" Esperando ronda... "),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_content, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_v_btn, {
                                                          class: "mt-2",
                                                          variant: "tonal",
                                                          color: "secondary",
                                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (agregarPairing(activeTab.value)))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" Añadir partida ")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        (partidasPorRonda.value[activeTab.value])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                              _createTextVNode(" Faltan partidas por validar "),
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_16, [
                                                              _createVNode(_component_v_btn, {
                                                                class: "mt-2",
                                                                variant: "tonal",
                                                                color: "secondary",
                                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (agregarPairing(activeTab.value)))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Añadir partida ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ])),
                            (torneo.value?.tipoTorneo !== 'Individual')
                              ? (_openBlock(), _createBlock(CardEmparejamientosGestion, {
                                  key: 2,
                                  partidas: partidas.value,
                                  numeroRonda: activeTab.value,
                                  idTorneo: parseInt(_unref(route).params.idTorneo.toString())
                                }, null, 8, ["partidas", "numeroRonda", "idTorneo"]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partidasPorRonda.value[activeTab.value!], (partida, index) => {
                              return (_openBlock(), _createBlock(_component_v_tabs_item, {
                                key: partida.idPartidaTorneo,
                                value: activeTab.value
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_v_card, {
                                      class: "ma-3 bordered-card",
                                      "max-width": "400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "underlined-title" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Mesa " + _toDisplayString(index + 1), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_card_subtitle),
                                        _createVNode(_component_v_divider),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_18, [
                                              _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("div", null, _toDisplayString(partida.nombreEquipo1), 1),
                                                _createElementVNode("div", _hoisted_20, [
                                                  _createElementVNode("span", null, [
                                                    (partida.partidaValidadaUsuario1)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "green"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-check")
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 1,
                                                          color: "red"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })),
                                                    _createVNode(_component_v_btn, {
                                                      class: "mt-2",
                                                      variant: "tonal",
                                                      color: "primary",
                                                      size: "small",
                                                      onClick: ($event: any) => (
                                  abrirModalValidar(partida.idPartidaTorneo, 1)
                                )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Validar ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_21, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass({
                                highlight: partida.idUsuario1 === idUsuario.value,
                              })
                                                  }, _toDisplayString(partida.nick1), 3)
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                  (partida.resultadoUsuario1 != null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(partida.resultadoUsuario1), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]))
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                  (partida.liderMuertoUsuario1 != null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ¿General? " + _toDisplayString(partida.liderMuertoUsuario1 === true
                                  ? "Sí"
                                  : partida.liderMuertoUsuario1 === false
                                  ? "No"
                                  : "N/A"), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                                        _createTextVNode(" ¿General? "),
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]))
                                                ]),
                                                _createElementVNode("div", _hoisted_28, [
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-shield-outline")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createElementVNode("span", null, _toDisplayString(partida.ejercitoUsuario1 ?? "N/A"), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createVNode(_component_v_btn, {
                                                    class: "mt-2",
                                                    variant: "tonal",
                                                    color: "primary",
                                                    size: "small",
                                                    onClick: ($event: any) => (
                                verLista(
                                  partida.idUsuario1,
                                  partida.idTorneo,
                                  partida.nick1
                                )
                              )
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Lista ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ]),
                                              _createVNode(_component_v_divider, {
                                                vertical: "",
                                                class: "divider"
                                              }),
                                              _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", null, _toDisplayString(partida.nombreEquipo2), 1),
                                                _createElementVNode("div", _hoisted_31, [
                                                  _createElementVNode("span", null, [
                                                    (partida.partidaValidadaUsuario2)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "green"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-check")
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 1,
                                                          color: "red"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })),
                                                    _createVNode(_component_v_btn, {
                                                      class: "mt-2",
                                                      variant: "tonal",
                                                      color: "primary",
                                                      size: "small",
                                                      onClick: ($event: any) => (
                                  abrirModalValidar(partida.idPartidaTorneo, 2)
                                )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Validar ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_32, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass({
                                highlight: partida.idUsuario2 === idUsuario.value,
                              })
                                                  }, _toDisplayString(partida.nick2), 3)
                                                ]),
                                                _createElementVNode("div", _hoisted_33, [
                                                  (partida.resultadoUsuario2 != null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(partida.resultadoUsuario2), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]))
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                  (partida.liderMuertoUsuario2 != null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, " ¿General? " + _toDisplayString(partida.liderMuertoUsuario2 === true
                                  ? "Sí"
                                  : partida.liderMuertoUsuario2 === false
                                  ? "No"
                                  : "N/A"), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                        _createTextVNode(" ¿General? "),
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-close")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]))
                                                ]),
                                                _createElementVNode("div", _hoisted_39, [
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-shield-outline")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createElementVNode("span", null, _toDisplayString(partida.ejercitoUsuario2 ?? "N/A"), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_40, [
                                                  _createVNode(_component_v_btn, {
                                                    class: "mt-2",
                                                    variant: "tonal",
                                                    color: "primary",
                                                    size: "small",
                                                    onClick: ($event: any) => (
                                verLista(
                                  partida.idUsuario2,
                                  partida.idTorneo,
                                  partida.nick2
                                )
                              )
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Lista ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ])
                                            ]),
                                            _createVNode(_component_v_divider),
                                            _createVNode(_component_v_list, { class: "centered-list" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("mdi-trophy")
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(getGanador(partida)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("mdi-calendar")
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(formatDate(partida.fechaPartida)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("mdi-map-marker")
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(partida.escenarioPartida), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_41, [
                                                              _createVNode(_component_v_btn, {
                                                                class: "mt-2",
                                                                variant: "tonal",
                                                                color: "secondary",
                                                                onClick: ($event: any) => (modificarPartida(partida))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Modificar Resultado ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_42, [
                                                              _createVNode(_component_v_btn, {
                                                                class: "mt-2",
                                                                variant: "tonal",
                                                                color: "secondary",
                                                                onClick: ($event: any) => (modificarPairing(partida))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Modificar Pairing ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_43, [
                                                              _createVNode(_component_v_btn, {
                                                                class: "mt-2",
                                                                variant: "tonal",
                                                                color: "error",
                                                                onClick: ($event: any) => (eliminarPartida(partida))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Eliminar partida ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128)),
                            _createVNode(TabClasificacionEquipos, {
                              tabClasificacion: tabClasificacion.value,
                              activeTab: activeTab.value,
                              torneo: torneo.value,
                              partidas: partidas.value,
                              equipos: torneoGestion.value?.equipos,
                              onEnviarClasificacion: manejarClasificacion
                            }, null, 8, ["tabClasificacion", "activeTab", "torneo", "partidas", "equipos"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isModalListaVisible.value)
        ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
            key: 0,
            listaData: listaData.value,
            nickJugador: nickJugador.value,
            ejercito: currentEjercito.value,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (isModalListaVisible.value = false))
          }, null, 8, ["listaData", "nickJugador", "ejercito"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: isLoadingImage.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isLoadingImage).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (isModalPuntosVisible.value)
        ? (_openBlock(), _createBlock(ModalAddPuntosPartida, {
            key: 1,
            isVisible: isModalPuntosVisible.value,
            idPartidaTorneo: idPartidaSeleccionada.value,
            usuario: usuarioSeleccionado.value,
            onConfirmar: confirmarPuntos,
            onCerrar: cerrarModal
          }, null, 8, ["isVisible", "idPartidaTorneo", "usuario"]))
        : _createCommentVNode("", true),
      (isModalLiderVisible.value)
        ? (_openBlock(), _createBlock(ModalLiderPartida, {
            key: 2,
            isVisible: isModalLiderVisible.value,
            idPartidaTorneo: idPartidaSeleccionada.value,
            usuario: usuarioSeleccionado.value,
            onConfirmar: confirmarLider,
            onCerrar: cerrarModalLider
          }, null, 8, ["isVisible", "idPartidaTorneo", "usuario"]))
        : _createCommentVNode("", true),
      (isModalEscenarioVisible.value)
        ? (_openBlock(), _createBlock(ModalAddEscenarioPartida, {
            key: 3,
            isVisible: isModalEscenarioVisible.value,
            idPartidaTorneo: idPartidaSeleccionada.value,
            usuario: usuarioSeleccionado.value,
            onConfirmar: confirmarEscenario,
            onCerrar: cerrarModalEscenario
          }, null, 8, ["isVisible", "idPartidaTorneo", "usuario"]))
        : _createCommentVNode("", true),
      (isModalValidarVisible.value)
        ? (_openBlock(), _createBlock(ModalValidarPartida, {
            key: 4,
            isVisible: isModalValidarVisible.value,
            idPartidaTorneo: idPartidaSeleccionada.value,
            onConfirmar: confirmarValidar,
            onCerrar: cerrarModalValidar
          }, null, 8, ["isVisible", "idPartidaTorneo"]))
        : _createCommentVNode("", true),
      _createVNode(ModalParametrosRondasEquipo, {
        isVisible: showConfigModal.value,
        torneo: torneoGestion.value,
        clasificacion: clasificacionEquipos.value,
        ronda: rondaAGenerar.value,
        partidas: partidas.value,
        onClose: closeConfigModal,
        onConfirm: handleConfigConfirm
      }, null, 8, ["isVisible", "torneo", "clasificacion", "ronda", "partidas"]),
      _createVNode(ModalEditarPartidaGestion, {
        isVisible: showModificarPartidaTorneoModal.value,
        partida: partidaActual.value,
        onCerrar: closeModificarPartidaTorneoModal,
        onConfirm: handleModificarPartidaTorneoConfirm
      }, null, 8, ["isVisible", "partida"]),
      _createVNode(ModalCambiarPairingEquipoGestion, {
        isVisible: showModificarPairingModal.value,
        idEquipo1: partidaActual.value.idEquipo1!,
        idEquipo2: partidaActual.value.idEquipo2!,
        nombreEquipo1: partidaActual.value.nombreEquipo1!,
        nombreEquipo2: partidaActual.value.nombreEquipo2!,
        partida: partidaActual.value,
        onActualizar: actualizarPairing,
        onCerrar: _cache[10] || (_cache[10] = ($event: any) => (showModificarPairingModal.value = false))
      }, null, 8, ["isVisible", "idEquipo1", "idEquipo2", "nombreEquipo1", "nombreEquipo2", "partida"]),
      _createVNode(ModalAgregarPairing, {
        isVisible: showAgregarPairingModal.value,
        idTorneo: idTorneo.value!,
        idRonda: idRondaSelected.value,
        onCerrar: closeAgregarPairingModal
      }, null, 8, ["isVisible", "idTorneo", "idRonda"]),
      _createVNode(ModalEliminarPartidaTorneo, {
        isVisible: showEliminarPartidaModal.value,
        partida: partidaActual.value,
        onCerrar: closeEliminarPartidaModal,
        onConfirm: handleEliminarPartidaConfirm
      }, null, 8, ["isVisible", "partida"]),
      _createVNode(ModalSuccess, {
        isVisible: showSuccessModal.value,
        message: "Acción realizada correctamente.",
        "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showSuccessModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "No se han podido guardar los resultados. Intentalo de nuevo y si el error persiste contacta con el administrador.",
        "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorCambiarPairingModal.value,
        message: "Ha ocurrido un error al cambiar el emparejamiento. Inténtalo de nuevo o contacta al administrador del torneo.",
        "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => (showErrorCambiarPairingModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(_component_v_dialog, {
        modelValue: isGenerating.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isGenerating).value = $event)),
        "hide-overlay": "",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "progress-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "70"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})